import React from 'react';
import Card from '@mui/material/Card';
import Icon from '@mui/material/Icon';
import { alpha, useTheme as useMuiTheme } from '@mui/material/styles';
import MDBox from 'components/MDBox';
import MDTypography from 'components/MDTypography';
import MDButton from 'components/MDButton';
import { useNavigate } from 'react-router-dom';

export function TrialUpgradeCard() {
  const theme = useMuiTheme();
  const navigate = useNavigate();

  const handleGoPlans = () => {
    navigate('/app/pilates/packages');
  };

  const accent = theme.palette.warning.main;

  const items = [
    'Seans hatırlatma',
    'Paket yenileme uyarıları',
    'Gelişmiş raporlar',
    'Eğitmen performansı',
  ];

  return (
    <Card
      sx={{
        borderRadius: 3,
        border: `1px solid ${theme.palette.divider}`,
        background: theme.palette.background.paper,
        boxShadow: 'none',
      }}
    >
      <MDBox p={2.25}>
        {/* Header */}
        <MDBox display="flex" alignItems="center" justifyContent="space-between" mb={1.25}>
          <MDBox display="flex" alignItems="center" gap={1}>
            <MDBox
              sx={{
                width: 34,
                height: 34,
                borderRadius: 2,
                display: 'grid',
                placeItems: 'center',
                background: alpha(accent, 0.14),
                color: accent,
              }}
            >
              <Icon sx={{ fontSize: 20 }}>rocket_launch</Icon>
            </MDBox>

            <MDBox>
              <MDTypography variant="button" fontWeight="bold">
                Pro’ya geç
              </MDTypography>
            </MDBox>
          </MDBox>
        </MDBox>

        {/* List */}
        <MDBox sx={{ display: 'grid', gap: 0.6, mb: 1.5 }}>
          {items.map((t) => (
            <MDBox key={t} display="flex" alignItems="center" gap={0.8}>
              <MDBox
                sx={{
                  width: 6,
                  height: 6,
                  borderRadius: 99,
                  background: alpha(accent, 0.9),
                }}
              />
              <MDTypography variant="caption" sx={{ color: theme.palette.text.secondary }}>
                {t}
              </MDTypography>
            </MDBox>
          ))}
        </MDBox>

        {/* CTA */}
        <MDButton
          fullWidth
          variant="contained"
          color="dark"
          onClick={handleGoPlans}
          sx={{
            borderRadius: 2.5,
            py: 1,
            textTransform: 'none',
            fontWeight: 700,
          }}
        >
          Paketleri gör
        </MDButton>
      </MDBox>
    </Card>
  );
}
